import React from "react";

const RelationshipDetailsPopup = ({ selectedEdge, onClose }) => {
  if (!selectedEdge) return null;

  const sourceEntity =
    selectedEdge.source?.name ||
    selectedEdge.source?.data?.label ||
    selectedEdge.source ||
    "Unknown";
  const targetEntity =
    selectedEdge.target?.name ||
    selectedEdge.target?.data?.label ||
    selectedEdge.target ||
    "Unknown";
  const relationshipType =
    selectedEdge.type || selectedEdge.data?.relationshipType || "Unknown";
  const relationshipDescription =
    selectedEdge.description || selectedEdge.data?.description || "";
  const activeFrom =
    selectedEdge.active_from || selectedEdge.data?.active_from || "";
  const activeUntil =
    selectedEdge.active_until || selectedEdge.data?.active_until || "";
  const status = selectedEdge.status || selectedEdge.data?.status || "";

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center bg-black/50 md:items-center">
      <div className="max-h-[85dvh] w-full max-w-lg overflow-y-auto rounded-t-2xl bg-gray-800 p-6 pb-[max(1.5rem,env(safe-area-inset-bottom))] shadow-2xl md:mx-4 md:max-h-96 md:rounded-lg md:pb-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-xl font-bold text-white">Relationship Details</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white transition-colors text-xl"
            aria-label="Close popup"
          >
            ✕
          </button>
        </div>

        <div className="space-y-4">
          <div className="bg-gray-700 rounded-lg p-4">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm font-medium text-gray-300">
                Relationship Type
              </span>
              <span className="px-2 py-1 bg-blue-600 text-white text-xs rounded-full">
                {relationshipType}
              </span>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="bg-gray-700 rounded-lg p-4">
              <label className="text-sm font-medium text-gray-300 block mb-2">
                Source Entity
              </label>
              <div className="text-white font-medium">{sourceEntity}</div>
              {selectedEdge.source?.type && (
                <div className="text-gray-400 text-xs mt-1">
                  {selectedEdge.source.type}
                </div>
              )}
            </div>

            <div className="bg-gray-700 rounded-lg p-4">
              <label className="text-sm font-medium text-gray-300 block mb-2">
                Target Entity
              </label>
              <div className="text-white font-medium">{targetEntity}</div>
              {selectedEdge.target?.type && (
                <div className="text-gray-400 text-xs mt-1">
                  {selectedEdge.target.type}
                </div>
              )}
            </div>
          </div>

          {relationshipDescription && (
            <div className="bg-gray-700 rounded-lg p-4">
              <label className="text-sm font-medium text-gray-300 block mb-2">
                Relationship Description
              </label>
              <div className="text-gray-300 text-sm">
                {relationshipDescription}
              </div>
            </div>
          )}

          {/* Relationship Status and Dates */}
          {(status || activeFrom || activeUntil) && (
            <div className="bg-gray-700 rounded-lg p-4">
              <label className="text-sm font-medium text-gray-300 block mb-2">
                Relationship Details
              </label>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
                {status && (
                  <div>
                    <span className="text-gray-400">Status: </span>
                    <span
                      className={`px-2 py-1 rounded text-xs ${
                        status === "Approved"
                          ? "bg-green-600 text-white"
                          : status === "Proposed"
                            ? "bg-yellow-600 text-white"
                            : status === "Rejected"
                              ? "bg-red-700 text-white"
                              : status === "Deprecated"
                                ? "bg-red-600 text-white"
                                : "bg-gray-600 text-gray-300"
                      }`}
                    >
                      {status}
                    </span>
                  </div>
                )}
                {activeFrom && (
                  <div>
                    <span className="text-gray-400">Active From: </span>
                    <span className="text-gray-300">
                      {new Date(activeFrom).toLocaleDateString()}
                    </span>
                  </div>
                )}
                {activeUntil && (
                  <div>
                    <span className="text-gray-400">Active Until: </span>
                    <span className="text-gray-300">
                      {new Date(activeUntil).toLocaleDateString()}
                    </span>
                  </div>
                )}
              </div>
            </div>
          )}

          {selectedEdge.source?.description && (
            <div className="bg-gray-700 rounded-lg p-4">
              <label className="text-sm font-medium text-gray-300 block mb-2">
                Source Description
              </label>
              <div className="text-gray-300 text-sm">
                {selectedEdge.source.description}
              </div>
            </div>
          )}

          {selectedEdge.target?.description && (
            <div className="bg-gray-700 rounded-lg p-4">
              <label className="text-sm font-medium text-gray-300 block mb-2">
                Target Description
              </label>
              <div className="text-gray-300 text-sm">
                {selectedEdge.target.description}
              </div>
            </div>
          )}
        </div>

        <div className="mt-6 flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default RelationshipDetailsPopup;
